var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Recreate',{on:{"done":function($event){return _vm.load()}}}),_c('List',{staticClass:"my-5",attrs:{"loading":_vm.loading}}),_c('Form'),_c('EditParallax')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }